import React from 'react';

import './footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <a href="mailto:contact@webredone.com">contact@webredone.com</a>
    </footer>
  );
};

export default Footer;
